import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { motion } from "framer-motion";
import { FaBullseye, FaCheckCircle } from "react-icons/fa";

export default function VisiMisi() {
  const [visi, setVisi] = useState("");
  const [misi, setMisi] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const snap = await getDoc(doc(db, "profilSekolah", "main"));
      if (snap.exists()) {
        const data = snap.data();
        setVisi(data.visi || "");
        setMisi(data.misi || []);
      }
    };
    fetchData();
  }, []);

  return (
    <section
      style={{
        background: "linear-gradient(135deg, #f0f6ff, #dbeafe)",
        minHeight: "100vh",
        fontFamily: "'Poppins', sans-serif",
      }}
      className="py-5"
    >
      <div className="container">
        {/* Judul */}
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="fw-bold text-primary" style={{ letterSpacing: "1px" }}>
            Visi & Misi Sekolah
          </h2>
          <p className="text-muted mt-2" style={{ fontSize: "1.05rem" }}>
            Membangun generasi yang berilmu, berakhlak, dan berprestasi.
          </p>
          <div
            className="mx-auto mt-3"
            style={{
              width: "80px",
              height: "4px",
              backgroundColor: "#0d6efd",
              borderRadius: "5px",
            }}
          ></div>
        </motion.div>

        <div className="row align-items-center">
          {/* VISI */}
          <motion.div
            className="col-lg-5 mb-4 mb-lg-0"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="card shadow-lg border-0 p-4 h-100 rounded-4 bg-white">
              <div className="d-flex align-items-center mb-3">
                <FaBullseye className="text-primary me-2" size={26} />
                <h4 className="fw-bold text-primary mb-0">Visi</h4>
              </div>
              <p
                style={{
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  textAlign: "justify",
                  color: "#333",
                }}
              >
                {visi || "Belum ada visi yang ditambahkan."}
              </p>
            </div>
          </motion.div>

          {/* MISI */}
          <motion.div
            className="col-lg-7"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="card shadow-lg border-0 p-4 h-100 rounded-4 bg-white">
              <div className="d-flex align-items-center mb-3">
                <FaCheckCircle className="text-success me-2" size={26} />
                <h4 className="fw-bold text-success mb-0">Misi</h4>
              </div>
              {misi.length > 0 ? (
                <ul
                  className="list-unstyled mt-3"
                  style={{ fontSize: "1.05rem", color: "#333" }}
                >
                  {misi.map((item, idx) => (
                    <motion.li
                      key={idx}
                      className="d-flex align-items-start mb-2"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.4, delay: idx * 0.1 }}
                    >
                      <span className="text-success me-2 mt-1">•</span>
                      <span>{item}</span>
                    </motion.li>
                  ))}
                </ul>
              ) : (
                <p>Belum ada misi yang ditambahkan.</p>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
